import React from 'react';
import { useTranslation } from 'react-i18next';
import { formatEevnText } from '../../utils/formatEevnText';
import './About.css';

const About = () => {
  const { t } = useTranslation();

  return (
    <section className="about section" id="about">
      <div className="container">
        <h2 className="section-title">{t('about.title')}</h2>
        <div className="about-content">
          <div className="about-text">
            <p className="about-bio">{formatEevnText(t('about.bio'))}</p>
            <p className="about-location">{t('about.location')}</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;

